import background from "../../assets/images/jeans.jpg";
import { CategoryCardSizes } from "../../components";

const fixture = {
  size: CategoryCardSizes.H2,
  background,
  title: "Jeans",
};

export default fixture;
